import styled from 'styled-components';
import Container from 'react-bootstrap/Container';

//Contenedor principal de las cards
const ContenedorCards = styled(Container)`
      
      margin-top: auto;
      h2{
        font-family: "Dosis";
        font-weight: 700;
        color: black;
        font-weight: 700;
        margin: 50px 0px 40px 0px;
        text-align: center;

      }
      
      
      
      
      `
    

export default ContenedorCards;